/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePersonAddress,
  DeletePersonAddressRequest,
  GetAddressesParams,
  PersonAddressDto,
  UpdatePersonAddress
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetAddressesUrl = (params?: GetAddressesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/PersonAddress/GetAddresses?${stringifiedParams}` : `/api/PersonAddress/GetAddresses`
}

export const getAddresses = async (params?: GetAddressesParams, options?: Parameters<typeof customInstance>[1]): Promise<PersonAddressDto[]> => {

  return customInstance<PersonAddressDto[]>(getGetAddressesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAddressesQueryKey = (params?: GetAddressesParams,) => {
    return [
    `/api/PersonAddress/GetAddresses`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddresses>>> = ({ signal }) => getAddresses(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getAddresses>>>
export type GetAddressesQueryError = ErrorType<unknown>


export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAddressesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddresses>>,
          TError,
          Awaited<ReturnType<typeof getAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAddresses>>,
          TError,
          Awaited<ReturnType<typeof getAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAddressesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(params?: GetAddressesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAddressesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddresses>>> = ({ signal }) => getAddresses(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAddressesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAddresses>>>
export type GetAddressesSuspenseQueryError = ErrorType<unknown>


export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAddressesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
 params?: GetAddressesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAddressesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyAddressesUrl = () => {




  return `/api/PersonAddress/GetMyAddresses`
}

export const getMyAddresses = async ( options?: Parameters<typeof customInstance>[1]): Promise<PersonAddressDto[]> => {

  return customInstance<PersonAddressDto[]>(getGetMyAddressesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetMyAddressesQueryKey = () => {
    return [
    `/api/PersonAddress/GetMyAddresses`
    ] as const;
    }


export const getGetMyAddressesQueryOptions = <TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAddressesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAddresses>>> = ({ signal }) => getMyAddresses({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMyAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAddresses>>>
export type GetMyAddressesQueryError = ErrorType<unknown>


export function useGetMyAddresses<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAddresses>>,
          TError,
          Awaited<ReturnType<typeof getMyAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAddresses<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyAddresses>>,
          TError,
          Awaited<ReturnType<typeof getMyAddresses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAddresses<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyAddresses<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyAddressesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetMyAddressesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyAddressesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyAddresses>>> = ({ signal }) => getMyAddresses({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetMyAddressesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getMyAddresses>>>
export type GetMyAddressesSuspenseQueryError = ErrorType<unknown>


export function useGetMyAddressesSuspense<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAddressesSuspense<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMyAddressesSuspense<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetMyAddressesSuspense<TData = Awaited<ReturnType<typeof getMyAddresses>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getMyAddresses>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMyAddressesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreatePersonAddressUrl = () => {




  return `/api/PersonAddress/CreatePersonAddress`
}

export const createPersonAddress = async (createPersonAddressBody?: CreatePersonAddress, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getCreatePersonAddressUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPersonAddressBody)
  }
);}





export const getCreatePersonAddressMutationKey = () => ['createPersonAddress'] as const;

export const getCreatePersonAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonAddress>>, TError,CreatePersonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPersonAddress>>, TError,CreatePersonAddressMutationVariables, TContext> => {

const mutationKey = getCreatePersonAddressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPersonAddress>>, CreatePersonAddressMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPersonAddress(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonAddressMutationResult = NonNullable<Awaited<ReturnType<typeof createPersonAddress>>>
    export type CreatePersonAddressMutationBody = BodyType<CreatePersonAddress> | undefined
    export type CreatePersonAddressMutationError = ErrorType<unknown>
    export type CreatePersonAddressMutationVariables = {data?: BodyType<CreatePersonAddress>}

    export const useCreatePersonAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPersonAddress>>, TError,CreatePersonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPersonAddress>>,
        TError,
        CreatePersonAddressMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePersonAddressMutationOptions(options), queryClient);
    }
    export const getUpdatePerrsonAddressUrl = () => {




  return `/api/PersonAddress/UpdatePerrsonAddress`
}

export const updatePerrsonAddress = async (updatePersonAddress?: UpdatePersonAddress, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdatePerrsonAddressUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePersonAddress)
  }
);}





export const getUpdatePerrsonAddressMutationKey = () => ['updatePerrsonAddress'] as const;

export const getUpdatePerrsonAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerrsonAddress>>, TError,UpdatePerrsonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePerrsonAddress>>, TError,UpdatePerrsonAddressMutationVariables, TContext> => {

const mutationKey = getUpdatePerrsonAddressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePerrsonAddress>>, UpdatePerrsonAddressMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePerrsonAddress(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePerrsonAddressMutationResult = NonNullable<Awaited<ReturnType<typeof updatePerrsonAddress>>>
    export type UpdatePerrsonAddressMutationBody = BodyType<UpdatePersonAddress> | undefined
    export type UpdatePerrsonAddressMutationError = ErrorType<unknown>
    export type UpdatePerrsonAddressMutationVariables = {data?: BodyType<UpdatePersonAddress>}

    export const useUpdatePerrsonAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePerrsonAddress>>, TError,UpdatePerrsonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePerrsonAddress>>,
        TError,
        UpdatePerrsonAddressMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePerrsonAddressMutationOptions(options), queryClient);
    }
    export const getDeletePersonAddressUrl = () => {




  return `/api/PersonAddress/DeletePersonAddress`
}

export const deletePersonAddress = async (deletePersonAddressRequest?: DeletePersonAddressRequest, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getDeletePersonAddressUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(deletePersonAddressRequest)
  }
);}





export const getDeletePersonAddressMutationKey = () => ['deletePersonAddress'] as const;

export const getDeletePersonAddressMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonAddress>>, TError,DeletePersonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePersonAddress>>, TError,DeletePersonAddressMutationVariables, TContext> => {

const mutationKey = getDeletePersonAddressMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePersonAddress>>, DeletePersonAddressMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  deletePersonAddress(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePersonAddressMutationResult = NonNullable<Awaited<ReturnType<typeof deletePersonAddress>>>
    export type DeletePersonAddressMutationBody = BodyType<DeletePersonAddressRequest> | undefined
    export type DeletePersonAddressMutationError = ErrorType<unknown>
    export type DeletePersonAddressMutationVariables = {data?: BodyType<DeletePersonAddressRequest>}

    export const useDeletePersonAddress = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePersonAddress>>, TError,DeletePersonAddressMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePersonAddress>>,
        TError,
        DeletePersonAddressMutationVariables,
        TContext
      > => {
      return useMutation(getDeletePersonAddressMutationOptions(options), queryClient);
    }
